<template>
  <a v-if="link" 
    :href="link"
    :class="['button', `btn-hover`, `btn-hover--${colorClass}`, additionalClasses, { 'not-changed': !isFormChanged }]"
    @click="handleClick">
    <template v-if="localShowPreloader">
      <div :class="['btn-preloader', `btn-preloader--${colorClass}`]"></div>
    </template>
    <template v-else>
      <span v-if="buttonText">{{ buttonText }}</span>
      <slot v-else></slot>
    </template>
  </a>
  <button
    v-else
    :type="type"
    :class="['button', `btn-hover`, `btn-hover--${colorClass}`, additionalClasses, { 'not-changed': !isFormChanged }]"
    @click="handleClick"
  >
    <template v-if="localShowPreloader">
      <div :class="['btn-preloader', `btn-preloader--${colorClass}`]"></div>
    </template>
    <template v-else>
      <span v-if="buttonText">{{ buttonText }}</span>
      <slot v-else></slot>
    </template>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    type: {
      type: String,
      default: "button",
    },
    buttonText: {
      type: String,
      required: false,
    },
    isFormChanged: {
      type: Boolean,
      default: false,
    },
    colorClass: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    preloaderTimeout: {
      type: Number,
      default: 5000,
    },
    additionalClasses: {
      type: String,
      default: "",
    },
    showPreloader: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localShowPreloader: this.showPreloader
    };
  },
  watch: {
    showPreloader(newValue) {
      this.localShowPreloader = newValue;
    }
  },
  methods: {
    handleClick(event) {
      if (this.isFormChanged) {
        this.localShowPreloader = true;

        setTimeout(() => {
          this.localShowPreloader = false;
        }, this.preloaderTimeout);
      }
    },
  },
};
</script>